module.exports = __webpack_public_path__ + "static/assurance1-6669513d680bc4a8cfff455ee225e18b.jpg";